import FormBaseModel from '@cp-models/FormBaseModel';
import moment from 'moment';

export default class Bill extends FormBaseModel {
    casts()
    {
        return {
            'id': 'number',
            'external_id': 'number',
            'external_charge_id': 'number',
            'billing_at': 'any',
            'payment_method_code': 'string',
            'due_at': 'any',
            'paid_at': 'any',
            'canceled_at': 'any',
            'installments': 'number',
            'code': 'string',
            'number_code': 'string',
            'block_account': 'boolean',
            'subscription_id': 'number',
            'external_user_id': 'number',
            'created_at': 'any',
            'updated_at': 'any',
            'deleted_at': 'any',
            'url': 'string',
            'original_price': 'number',
            'paid_price': 'number',
            'nfe_url': 'string',
            'bill_items': 'array'
        }
    }

    get billingAt()
    {
        return this.billing_at ? this.formatDate(this.billing_at) : ''
    }

    get dueAt()
    {
        return this.due_at ? this.formatDate(this.due_at) : ''
    }

    get paidAt()
    {
        return this.paid_at ? this.formatDate(this.paid_at) : ''
    }

    get canceledAt()
    {
        return this.canceled_at ? this.formatDate(this.canceled_at) : ''
    }

    get createdAt()
    {
        return this.formatDate(this.created_at)
    }

    get updatedAt()
    {
        return this.formatDate(this.updated_at)
    }

    get deletedAt()
    {
        return this.deleted_at ? this.formatDate(this.deleted_at) : ''
    }

    get originalPriceBr()
    {
        return this.original_price ? this.formatCurrency(this.original_price) : ''
    }

    get paidPriceBr()
    {
        return this.paid_price ? this.formatCurrency(this.paid_price) : ''
    }

    get statusData()
    {
        let data = {
            color: 'grey lighten-2',
            textColor: 'black',
            icon: '$check',
            text: 'Em dia'
        }

        if (this.paid_at !== null) {
            data = {
                color: 'green',
                textColor: 'white',
                icon: '$check',
                text: 'Paga'
            }
        }

        if (this.due_at && moment(this.due_at).isBefore(moment()) && this.paid_at === null) {
            data = {
                color: 'red',
                textColor: 'white',
                icon: '$clock',
                text: 'Atrasada'
            }
        }

        if (this.canceled_at !== null) {
            data = {
                color: 'red',
                textColor: 'white',
                icon: '$cancel',
                text: 'Cancelada'
            }
        }

        return data
    }

    get billType()
    {
        return this.subscription_id ? 'Mensalidade' : 'Fatura Avulsa'
    }

}
